import React from "react";
import ContentWrapper from "./ContentWrapper";
import InfoMessage from "./InfoMessage";
import { getLabel } from "../InitData";

export default function NotFound(props) {
    return (
        <ContentWrapper columns="1">
            <InfoMessage text={getLabel('general.page_not_found')} />
        </ContentWrapper>
    );
}
